import React, { Component } from "react";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";
import { TextShow } from "../Essentials/TextShow";
import NotificationDescription from "../Notifications/NotificationDescription";

class AboutUsDescription extends Component {
  render() {
    return (
      <div>
        {this.props.type == "message-from-the-principal" ? (
          <TextShow
            title="Message from the Principal"
            type="ABOUTUS_PRINCIPAL_MESSAGE"
          />
        ) : null}

        {this.props.type == "message-from-the-coordinator" ? (
          <TextShow
            title="Message from the Coordinator"
            type="ABOUTUS_COORDINATOR_MESSAGE"
          />
        ) : null}

        {this.props.type == "dispur-college-at-a-glance" ? (
          <TextShow
            title="Dispur College at a Glance"
            type="ABOUTUS_COLLEGE_GLANCE"
          />
        ) : null}

        {this.props.type == "about-the-cell" ? (
          <TextShow title="About the Cell" type="ABOUTUS_ABOUT_THE_CELL" />
        ) : null}

        {this.props.type == "genesis" ? (
          <TextShow title="Genesis" type="ABOUTUS_GENESIS" />
        ) : null}

        {this.props.type == "organogram" ? (
          <div>
            <BreadCrumbOwn title="Organogram" />
            <NotificationDescription
              title="Organogram"
              code="ABOUTUS_ORGANOGRAM"
            />
          </div>
        ) : null}
      </div>
    );
  }
}

export default AboutUsDescription;
